import React from 'react'

export function Pagination({ maxPages, currentPage, onClickChange }) {
  const pagesOnEachSiteOfCurrentPage = 2
  if (maxPages <= 1) {
    return null
  }

  const paginationPages = () => {
    const startIndex = currentPage - pagesOnEachSiteOfCurrentPage > 0 ? currentPage - pagesOnEachSiteOfCurrentPage : 1
    const endIndex =
      currentPage + pagesOnEachSiteOfCurrentPage < maxPages ? currentPage + pagesOnEachSiteOfCurrentPage : maxPages

    const paginationElements = []
    for (let i = startIndex; i <= endIndex; i++) {
      if (currentPage === i) {
        paginationElements.push(
          <div key={i} className='mtt-pagination__toggle mtt-pagination__toggle--active'>
            {i}
          </div>
        )
        continue
      }

      paginationElements.push(
        <div key={i} className='mtt-pagination__toggle' onClick={() => onClickChange(i)}>
          {i}
        </div>
      )
    }

    return paginationElements
  }

  return (
    <div className='mtt-pagination'>
      {currentPage !== 1 ? (
        <div className='mtt-pagination__toggle' onClick={() => onClickChange(currentPage - 1)}>
          &lt;
        </div>
      ) : null}

      {currentPage - pagesOnEachSiteOfCurrentPage > 1 ? (
        <>
          <div className='mtt-pagination__toggle' onClick={() => onClickChange(1)}>
            1
          </div>
          <div className='mtt-pagination__toggle mtt-pagination__toggle--dots'>...</div>
        </>
      ) : null}

      {paginationPages()}

      {currentPage + pagesOnEachSiteOfCurrentPage < maxPages ? (
        <>
          <div className='mtt-pagination__toggle mtt-pagination__toggle--dots'>...</div>
          <div className='mtt-pagination__toggle' onClick={() => onClickChange(maxPages)}>
            {maxPages}
          </div>
        </>
      ) : null}

      {currentPage !== maxPages ? (
        <div className='mtt-pagination__toggle' onClick={() => onClickChange(currentPage + 1)}>
          &gt;
        </div>
      ) : null}
    </div>
  )
}
